const server = process.env.NODE_ENV === 'development'
  ? 'http://flossy.local:8000'
  : 'https://shell-patterns.llia.io/api'

export function createURL(endpoint, params) {
  let query = ''
  if (params) {
    const usp = new URLSearchParams()
    for (const [key, value] of Object.entries(params)) {
      const values = Array.isArray(value) ? value : [value]
      values.forEach((v) => {
        usp.append(key, v)
      })
    }
    query = usp.toString()
  }

  if (endpoint[0] !== '/') {
    endpoint = `/${endpoint}`
  }

  return `${server}${endpoint}?${query}`
}

async function fetchEndpoint(method, endpoint, params) {
  const url = createURL(endpoint, params)

  try {
    const response = await fetch(url, { method })
    if (method === 'GET') {
      return await response.json()
    }
    return true
  } catch (e) {
    console.error('no server connection')
  }
  return null
}

export function get(endpoint, params) {
  return fetchEndpoint('GET', endpoint, params)
}

export function post(endpoint, params) {
  return fetchEndpoint('POST', endpoint, params)
}

export function put(endpoint, params) {
  return fetchEndpoint('PUT', endpoint, params)
}

export function del(endpoint, params) {
  return fetchEndpoint('DELETE', endpoint, params)
}
